<template>
  <div class="navigation-bar" :class="{ small: small }" :style="finalStyle">
    <div class="left">
      <slot name="left">
        <button v-if="!hideBack" class="btn-back" @click="goBack">
          <slot name="backIcon">
            <img src="../assets/svg-icons/back.svg" />
          </slot>
        </button>
      </slot>
    </div>
    <div class="center">
      <slot name="title">
        <h1 class="title">{{ title }}</h1>
      </slot>
    </div>
    <div class="right">
      <slot name="right" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useEnvStore } from "@/states/env";
import { storeToRefs } from "pinia";
import { useRouterAdv } from "@/composables/use-router-adv";

const store = useEnvStore();
const { statusBarHeight, navigationBarHeight } = storeToRefs(store);

/**
 * 导航栏
 */
const props = withDefaults(
  defineProps<{
    title?: string;
    hideBack?: any;
    small?: boolean;
  }>(),
  {
    title: "",
    hideBack: false,
    small: false,
  },
);
const finalStyle = computed(() => {
  return {
    paddingTop: `${statusBarHeight.value}px`,
    height: `${navigationBarHeight.value}px`,
  };
});
const routerAdv = useRouterAdv();
const goBack = () => {
  routerAdv.back();
};
</script>

<style lang="scss" scoped>
.navigation-bar {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: white;
  z-index: 200;

  &.small {
    .left,
    .right {
      width: 48px;
    }
  }

  .left,
  .right {
    display: flex;
    width: 96px;

    .btn-back,
    :deep(button) {
      background: transparent;
      border: none;
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .btn-back {
      justify-content: flex-start;
      padding-left: 10px;
    }
  }
  .right {
    justify-content: end;
    align-items: center;
  }

  .center {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
      margin: 0;
      font-weight: 600;
      font-size: 18px;
      color: #333333;
      line-height: 25px;
    }
  }
}
</style>
